"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusItemStyle = void 0;
const tslib_1 = require("tslib");
const UIHelper_1 = tslib_1.__importDefault(require("../../UIHelper"));
const getStatusItemStyle = (systemStatusMessageInfo) => {
    var _a;
    const background = UIHelper_1.default.getColorByMessageType((_a = systemStatusMessageInfo === null || systemStatusMessageInfo === void 0 ? void 0 : systemStatusMessageInfo.statusType) !== null && _a !== void 0 ? _a : 'Success');
    const color = systemStatusMessageInfo
        ? UIHelper_1.default.getButtonTextColourForMessageType(systemStatusMessageInfo.statusType)
        : 'var(--ab-color-text-on-primary)';
    return {
        background,
        color,
    };
};
exports.getStatusItemStyle = getStatusItemStyle;
